import React, { useContext } from "react";

import AuthContext from "../../context/auth_context.js";
import { Navigate } from "react-router-dom";
import ThemeWrapper from "../../components/ThemeWrapper";

const SecurityRoute = ({
  redirectPath = "/",
  component: Component,
  ...otherProps
}) => {
  const auth = useContext(AuthContext);
  if (!auth?.validUser) {
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <div className="main-content">
      <ThemeWrapper>
        <Component {...otherProps} />
      </ThemeWrapper>
    </div>
  );
};

export default SecurityRoute;
